// The page for a path that no route of the layout matches (ADR-0027).
//
// Each layout ends with a catch-all route to this page. A feature that the
// Feature Manifest does not enable has no routes in the build, so its paths
// end here too. The page says nothing about the feature: a client must not
// learn about a module that it did not buy (ADR-0027 D5).
import { PageHeader } from '@/components/ui';
import EmptyState from '@/components/EmptyState';

export default function NotFoundPage({ inStaffShell = true }: { inStaffShell?: boolean }) {
    return (
        <div className="flex h-full flex-col">
            <PageHeader title="Page not found" />
            <div className="flex-1 overflow-y-auto">
                <div className="max-w-content mx-auto px-content-padding pt-2">
                    <EmptyState
                        title="Page not found"
                        body={
                            inStaffShell
                                ? 'This page does not exist. Use the sidebar to open a page.'
                                : 'This page does not exist.'
                        }
                    />
                </div>
            </div>
        </div>
    );
}
